import { Text } from "@/components/ui/text";
import { TEST_IDS } from "@/testIdDefinition";

type ProfileFieldReadOnlyValueProps = {
    text: string | null;
};

export function ProfileFieldReadOnlyValue({
    text,
}: ProfileFieldReadOnlyValueProps) {
    return (
        <Text
            className="text-muted-foreground"
            testID={TEST_IDS[TEST_IDS.PROFILE_FIELD_READONLY_VALUE]}
        >
            {text?.trim() ? text : "None"}
        </Text>
    );
}
